import type { Tint } from '@terrazzo/core'

/** A card's color (SPEC §7.10): sets --k (its solid color) and washes the card in it. Plain: no class. */
export const tintClass = (tint: Tint | undefined) => (tint && tint !== 'none' ? `tint-${tint} tinted` : '')
/** Just a card color's --k (for a dot, a bar or a square in it). */
export const tintVar = (tint: Tint | undefined) => (tint && tint !== 'none' ? `tint-${tint}` : '')
